// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface TitleTypographyStyle {
    title?: TypographyProps;
}

const titleTypographyStyle: TitleTypographyStyle = {
    title: {
        variant: "h2",
        transform: "capitalize",
    },
};

const style = titleTypographyStyle;

type Props = {
    title?: string;
    primaryTitle?: string;
    secondaryTitle?: string;
    display?: string;
    marginBottom?: number;
    textAlign?: "left" | "right" | "center";
    [key: string]: any;
} & TypographyPresentationProps;

const splitTitle = (title: string) => {
    const primary = title?.split(" ")[0];
    let secondary;
    if (title.split(" ").length > 1) {
        secondary = title?.replace(`${primary} `, "");
    }

    return {
        primary,
        secondary,
    };
};

export const TitleTypography: FC<Props> = ({
    title,
    primaryTitle,
    secondaryTitle,
    display,
    marginBottom,
    textAlign,
    ...otherProps
}) => {
    if (!primaryTitle && !secondaryTitle && !title) {
        return null;
    }
    if (title && !primaryTitle && !secondaryTitle) {
        const { primary, secondary } = splitTitle(title);
        primaryTitle = primary;
        secondaryTitle = secondary;
    }

    return (
        <Typography
            {...style.title}
            {...otherProps}
            css={css`
                ${style.title?.css}
                ${otherProps.css}
                ${
                    display !== undefined &&
                    css`
                        display: ${display};
                    `
                }
                ${
                    marginBottom !== undefined &&
                    css`
                        margin-bottom: ${marginBottom}px;
                    `
                }
                ${
                    textAlign !== undefined &&
                    css`
                        text-align: ${textAlign};
                    `
                }
            `}
        >
            {primaryTitle} {secondaryTitle && <Typography color="common.secondary2">{secondaryTitle}</Typography>}
        </Typography>
    );
};

TitleTypography.defaultProps = {
    display: "block",
    textAlign: "center",
    marginBottom: 30,
};

export default TitleTypography;
